export default __webpack_public_path__ + "static/media/red-cross.1229f596.svg";